import { FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  h1: FelaCSSWithCustomSelectors;
  hiddenButton: FelaCSS;
}

const styles: IStyles = {
  h1: {
    fontSize: '36px',
    fontWeight: 800,
    '@container (width > 768px)': {
      fontSize: '64px',
    },
  },
  hiddenButton: {
    width: '280px',
    visibility: 'hidden',
    pointerEvents: 'none',
  },
};

export default styles;
